import type { ReactNode } from "react";

type BadgeProps = {
  children: ReactNode;
  variant?: "default" | "success" | "warning" | "error" | "info" | "pending" | "processing";
  className?: string;
};

const variantClasses = {
  default: "bg-gray-100 text-gray-800",
  success: "bg-green-100 text-green-800",
  warning: "bg-yellow-100 text-yellow-800",
  error: "bg-red-100 text-red-800",
  info: "bg-blue-100 text-blue-800",
  pending: "bg-orange-100 text-orange-800",
  processing: "bg-purple-100 text-purple-800",
};

export function Badge({ children, variant = "default", className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 font-medium text-xs ${variantClasses[variant]}
        ${className}
      `}
    >
      {children}
    </span>
  );
}

// ステータスに応じたBadgeバリアントを返すヘルパー
export function getStatusBadgeVariant(status: string): BadgeProps["variant"] {
  switch (status) {
    case "COMPLETED":
      return "success";
    case "FAILED":
      return "error";
    case "PROCESSING":
      return "processing";
    case "PENDING":
      return "pending";
    case "RETRYABLE":
      return "warning";
    case "CANCELLED":
      return "default";
    default:
      return "default";
  }
}

// マッチレベルに応じたBadgeバリアントを返すヘルパー
export function getMatchLevelBadgeVariant(level: number | null): BadgeProps["variant"] {
  if (level === null) {
    return "default";
  }
  if (level >= 4) {
    return "success";
  }
  if (level >= 3) {
    return "info";
  }
  if (level >= 2) {
    return "warning";
  }
  return "error";
}
